import PropTypes from 'prop-types'
import classnames from 'classnames'

import {Box, BoxGutterMedium} from '../../../../dashboard/src/components/blocks/Boxes'
import {TextGutterMedium, Text} from '../../../../dashboard/src/components/blocks/Texts'

import './tfaSignInFrame.scss'

const TfaSignInFrame = props => (
  <Box className={classnames(props.className, 'tfa-sign-in-frame', 'flex-container')}>
    <h3>{props.heading}</h3>
    <TextGutterMedium className='subtitle'>
      {props.subtitle}
    </TextGutterMedium>
    <BoxGutterMedium className='options-container flex-container'>
      {props.children}
    </BoxGutterMedium>
    <Text className='footer flex-container'>
      {props.footer}
    </Text>
  </Box>
)

TfaSignInFrame.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  footer: PropTypes.node.isRequired
}

export default TfaSignInFrame
